<template>
  <b-modal
    id="modal-associate-case"
    ref="bModal"
    :title="$t('registry.btn.associatedCases')"
    :lazy="true"
    modal-class="associateCaseModal"
    centered
    qa="modal-associate-case"
    @show="onShow"
  >
    <!--New card sample-->
    <b-row class="mx-0 my-1">
      <b-col class="pl-0 pr-0 px-5 mt-2">
        <div class="entity-card">
          <b-row class="py-2 px-3">
            <b-col class="d-flex align-items-center">
              <i
                class="far fa-user-circle mr-2 main"
                aria-hidden="true"
              />
              <span
                class="entity-card__title d-flex align-items-center font-weight--medium"
                qa="modal-associate-case-patient-card-fullname-span"
              >
                {{ patient.fullName }}
              </span>
            </b-col>
          </b-row>
          <div class="horizontal-divider" />
          <b-row class="py-2 px-4">
            <b-col
              v-if="globalParameters.mainPatientIdentifierType"
              class="entity-card__data"
            >
              <span class="entity-card__data--label">{{ globalParameters.mainPatientIdentifierType.name }}</span>
              <span
                class="entity-card__data--text"
                qa="modal-associate-case-patient-main-identifier-span"
              >{{ patient.mainPatientIdentifier ? patient.mainPatientIdentifier.paiIdentifier : '-' }}</span>
            </b-col>
            <b-col
              class="entity-card__data"
            >
              <span class="entity-card__data--label">{{ globalParameters.secondaryPatientIdentifierType.name }}</span>
              <span
                class="entity-card__data--text"
                qa="modal-associate-case-patient-secondary-identifier-span"
              >{{ patient.secondaryPatientIdentifier ? patient.secondaryPatientIdentifier.paiIdentifier : '-' }}</span>
            </b-col>
            <b-col
              class="entity-card__data"
            >
              <span class="entity-card__data--label">{{ $t('entities.patient.gender') }}</span>
              <span
                class="entity-card__data--text"
                qa="modal-associate-case-patient-gender-span"
              >{{ patient.genderCode }}</span>
            </b-col>
            <b-col
              class="entity-card__data"
            >
              <span class="entity-card__data--label">{{ $t('entities.patient.birthdate') }}</span>
              <span
                class="entity-card__data--text"
                qa="modal-associate-case-patient-birthdate-span"
              >{{ patient.patBirthdate | date }}</span>
            </b-col>
            <b-col
              class="entity-card__data"
            >
              <span class="entity-card__data--label">{{ $t('global.age') }}</span>
              <span
                class="entity-card__data--text"
                qa="modal-associate-case-patient-age-span"
              >{{ patientTimeOld }}</span>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-row class="pl-5 pr-5 my-3">
      <b-col>
        <b-row>
          <b-col>
            <div
              qa="modal-associate-case-available-cases-column"
              class="column"
            >
              <div class="title text-center">
                {{ $t('component.AssociateCaseModal.availableCases') }}
              </div>
              <div class="filter p-1">
                <vt-input
                  v-model="availableInput"
                  qa="modal-associate-case-available-cases-filter-input"
                  class="form-control form-control-sm"
                  type="text"
                  :placeholder="$t('component.protocolsModal.filter')"
                />
              </div>
              <div class="content">
                <div class="content">
                  <b-button
                    v-for="(availableCase, index) in filteredAvailableCases"
                    :key="index"
                    :qa="`modal-associate-case-${availableCase.casenumber}-button`"
                    :disabled="!$_canAssociateCases()"
                    block
                    variant="link"
                    class="secondary-button associate-case-btn"
                    @click="addAssociatedCase(availableCase, index)"
                  >
                    {{ availableCase.casenumber }}
                  </b-button>
                  <div
                    v-if="!filteredAvailableCases.length"
                    class="h-100 d-flex flex-column align-items-center justify-content-center"
                  >
                    <i
                      class="fal fa-empty-set mb-2"
                      aria-hidden="true"
                    />
                    <span class="is-italic">{{ $t('registry.modal.noCasesAvailable') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="$_canAssociateCases()"
            cols="1"
            class="p-0"
          >
            <div class="buttons d-flex flex-column justify-content-center h-100 text-center">
              <i
                class="far fa-long-arrow-right fa-2x mb-2"
                aria-hidden="true"
              />
              <i
                class="far fa-long-arrow-left fa-2x"
                aria-hidden="true"
              />
            </div>
          </b-col>
          <b-col>
            <div
              qa="modal-associate-case-associated-cases-column-div"
              class="column"
            >
              <div class="title text-center">
                {{ $t('component.AssociateCaseModal.associatedCases') }} a {{ caseNumber }}
              </div>
              <div class="filter p-1">
                <vt-input
                  v-model="associatedInput"
                  qa="modal-associate-case-associated-cases-filter-input"
                  class="form-control form-control-sm"
                  type="text"
                  :placeholder="$t('component.protocolsModal.filter')"
                />
              </div>
              <div class="content">
                <div class="content">
                  <b-button
                    v-for="(associatedCase, index) in filteredAssociatedCases"
                    :key="index"
                    :qa="`modal-associate-case-${associatedCase.casenumber}-button`"
                    :disabled="!$_canAssociateCases()"
                    block
                    variant="link"
                    class="secondary-button associate-case-btn"
                    @click="removeAssociatedCase(associatedCase, index)"
                  >
                    {{ associatedCase.casenumber }}
                  </b-button>
                  <div
                    v-if="!filteredAssociatedCases.length"
                    class="h-100 d-flex flex-column align-items-center justify-content-center"
                  >
                    <i
                      class="fal fa-empty-set mb-2"
                      aria-hidden="true"
                    />
                    <span class="is-italic">{{ $t('registry.modal.noAssociatedCases') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            qa="modal-associate-case-cancel-button"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            v-if="$_canAssociateCases()"
            qa="modal-associate-case-save-button"
            class="btn--primary btn-sm"
            :params="{ promise: save }"
          >
            <i
              class="far fa-save mr-2"
              aria-hidden="true"
            />{{ $t('global.save') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
    <div
      v-if="isLoading"
      class="spinner-wrapper"
    >
      <vt-loading />
    </div>
  </b-modal>
</template>

<script>
import CaseServices from '@/modules/RegistryModule/services/registryCaseServices'
import { find, filter, cloneDeep } from 'lodash'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'

export default {
    name: 'ModalAssociateCase',
    components: {},
    mixins: [CaseOperationGuardMixin],
    props: {
        associatedCases: { type: Array },
        labId: { type: Number },
        caseId: { type: Number },
        patient: { type: Object },
        casesByOwnerLaboratory: { type: Array },
        caseNumber: { type: String }
    },
    data() {
        return {
            isLoading: false,
            availableInput: '',
            associatedInput: '',
            availableCases: [],
            internalAssociatedCases: [],
            internalCasesByOwnerLaboratory: []
        }
    },
    computed: {
        patientTimeOld() {
            if (this.patient) return this.getPatientTimeOld(this.patient.patBirthdate)
            return ''
        },
        filteredAssociatedCases() {
            if (this.internalAssociatedCases.length) {
                return this.internalAssociatedCases.filter(associatedCase => associatedCase.casenumber.toUpperCase().includes(this.associatedInput.toUpperCase()))
            } else {
                return []
            }
        },
        filteredAvailableCases() {
            if (this.availableCases.length) {
                return this.availableCases.filter(associatedCase => associatedCase.casenumber.toUpperCase().includes(this.availableInput.toUpperCase()))
            } else {
                return []
            }
        }
    },
    methods: {
        async save() {
            const identifiers = this.internalAssociatedCases.map((associatedCase) => associatedCase.id)
            this.updateLoading(true)
            const [err] = await this.toCall(CaseServices.updateAssociatedCases(this.labId, this.caseId, identifiers), true)
            this.updateLoading(false)
            if (err) {
                return
            }
            this.showSuccessModalGlobal()
            setTimeout(() => {
                this.hide()
                this.$emit('associatedCasesUpdated')
            }, 2500)
        },
        addAssociatedCase(associatedCase, index) {
            this.internalAssociatedCases.push(associatedCase)
            this.availableCases.splice(index, 1)
        },
        removeAssociatedCase(associatedCase, index) {
            this.availableCases.push(associatedCase)
            this.internalAssociatedCases.splice(index, 1)
        },
        checkCases() {
            if (this.internalAssociatedCases.length) {
                this.availableCases = filter(this.internalCasesByOwnerLaboratory, (previousCase) => !find(this.internalAssociatedCases, { id: previousCase.id }) && previousCase.id !== this.caseId)
                return
            }
            this.availableCases = filter(this.internalCasesByOwnerLaboratory, (previousCase) => previousCase.id !== this.caseId)
        },
        hide() {
            this.availableCases = []
            this.internalAssociatedCases = []
            this.internalCasesByOwnerLaboratory = []
            this.$refs.bModal.hide()
        },
        show() {
            this.internalAssociatedCases = cloneDeep(this.associatedCases)
            this.internalCasesByOwnerLaboratory = cloneDeep(this.casesByOwnerLaboratory)
            this.$refs.bModal.show()
            this.checkCases()
        },
        onShow() {
            this.associatedInput = ''
            this.availableInput = ''
        }
    }
}

</script>

<style lang="scss">

.associateCaseModal .modal-dialog{
    max-width: 60%;
}

.associateCaseModal .associate-case-btn {
    margin-top: 0;
    border-bottom: 1px solid vt-color(general-border);
    border-radius: 0;
}

.associateCaseModal .associate-case-btn:hover {
    background-color: vt-color(light-primary);
}

.form-check-input{
  position: relative;
  top:2px;
}

.sample-item{
  padding: 0 !important;
}

.sample-item li a{
  margin-left: 5rem;
}

.sample-item li a:hover{
  color: grey !important;
}

.sample-item li{
  transition: .3s;
}

.sample-item li:hover{
  background: vt-color(light-primary);
}

.associateCaseModal .modal-body{
    padding: 0 !important;
}

</style>

<style lang="scss" scoped>

h4{
  font-weight: normal;
  font-size: 1rem;
}

.modal-subheader{
  border-bottom: 1px solid vt-color(light-primary);
  padding: 1% 5%;
}

.vertical-line{
  width:1px;
  height: 30%;
  background:#dee2e6;
  display: inline-block;
}

.collapse-sample{
  border: 0;
  border-radius: 0;
  border-bottom:1px solid #dee2e6;
  margin-bottom: 0 !important;
}

.collapse-sample .card-header{
  transition: .3s;
  border: 0;
  background:none;
}

.collapse-sample .card-header:hover{
  background: vt-color(light-primary);
}

.collapse-sample span{
  position: relative;
  float: left;
  font-size: 0.9rem;
  color: #707070;
}

.collapse-sample i{
  position: relative;
  float: right;
  font-size: 1.2rem;
  cursor: pointer;
}

.collapse-sample .title{
  width: 70%;
  cursor:pointer;
}

.collapse-sample ul li{
  padding-top: 5px;
  list-style: none !important;
  font-size: 0.9rem;

}

.collapse-sample ul{
  padding-left: 1rem !important;
  margin-bottom: 0.5rem !important;
}

.line::before{
  content:"";
  position: absolute;
  width: 1px;
  height: 100px;
  background: #dadada;
  left: -10%;
  top: 43%;
}

.buttons i{
  font-size: 1.3rem;
}

.column{
   border: 1px solid rgba(0, 0, 0, 0.2) !important;
  -webkit-box-shadow: 1px 1px 5px 0 rgba(125,125,125,0.64);
  -moz-box-shadow: 1px 1px 5px 0 rgba(125,125,125,0.64);
  box-shadow: 1px 1px 5px 0 rgba(125,125,125,0.64);
}

.column .title{
  background-color: #e9ecef;
  color: #495057;
  border-color: #dee2e6;
  padding: 2% 10% !important;
  font-size: 0.9rem;
  font-weight: bold;
}

.column .content{
  height: 30vh;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: auto;
}

.content ul li{
  list-style: none;
}

.table .blocks{
  width: 50% !important;
}

.table{
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  -webkit-box-shadow: 1px 1px 5px 0 rgba(125,125,125,0.64);
  -moz-box-shadow: 1px 1px 5px 0 rgba(125,125,125,0.64);
  box-shadow: 1px 1px 5px 0 rgba(125,125,125,0.64);
  max-height: 30px !important;
  overflow: hidden;
  position: relative;
  color: #707070;
}

.filter{
  border-bottom: 1px solid #dee2e6;
}

.content ul li{
  list-style: none !important;
  transition: .3s;
  padding: 2%;
  font-size: 0.9rem;
}

.content ul li:hover{
  background: vt-color(light-primary);
  cursor: pointer;
}

.content ul{
  padding-left: 0;
  margin-bottom: 0.5rem !important;
}

.table td,
.table th{
  padding-left: 10% !important;
  padding-right: 10% !important;
  border-top: none !important;
}

.table td input{
  height: calc(1.5em + 0.5rem + -5px) !important;
}

.table-hover tbody tr:hover{
  background-color: vt-color(light-primary) !important;
}

.table-hover tbody tr{
  transition: .3s;
}

@media (max-width: 1300px){

.table{
  font-size: 0.9rem;
}

.sample-item li a{
  margin-left: 4rem;
}

}

</style>
